import Query from '../../components/Report';

const query = new Query('discover-stats-new-vs-old');

export default query;
